import { render, staticRenderFns } from "./ModuloFinanceiro.vue?vue&type=template&id=3d36cb46&"
import script from "./ModuloFinanceiro.vue?vue&type=script&lang=js&"
export * from "./ModuloFinanceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports